export default class Random {
  uid() {
    const currentTimeNumbers = String(new Date().getTime()).split('')
    const firstPart = currentTimeNumbers.slice(0, 5).join('')
    const secondPart = currentTimeNumbers.slice(5).join('')

    return `${this.string(4, 4)}-${firstPart}-${this.string(6)}-${secondPart}`
  }

  string(length: number, shift: number = 2): string {
    const str = Math.random()
      .toString(36)
      .slice(shift, length + shift)

    return str.padEnd(length, '0')
  }
}
